module.exports = __webpack_public_path__ + "img/border-2.7e2a3617.svg";